import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { Router } from '@angular/router';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  AbstractControl
} from '@angular/forms';
import { ArcValidators } from '@arc/arc-shared-frontend';

@Component({
  selector: 'app-authentication-codeverification',
  styleUrls: ['./codeverification.component.scss'],
  templateUrl: './codeverification.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CodeVerificationComponent implements OnInit {
  @Input()
  showMessage = false;
  @Input()
  email;
  @Output()
  setVerificationClicked = new EventEmitter<string>();
  @Output()
  resendCodeClicked = new EventEmitter<string>();
  @Output()
  goBackClicked = new EventEmitter<any>();

  verificationFormGroup: UntypedFormGroup;
  verificationCodeControl = new UntypedFormControl('', {
    validators: []
  });
  emailFormControl = new UntypedFormControl('', {
    validators: []
  });

  constructor() {}

  ngOnInit() {
    this.verificationFormGroup = new UntypedFormGroup({
      verificationCode: this.verificationCodeControl,
      email: this.emailFormControl
    });
    this.verificationFormGroup.patchValue({ email: this.email });
  }

  setPassword() {
    this.verificationCodeControl.clearValidators();
    this.emailFormControl.clearValidators();
    this.verificationCodeControl.markAsTouched();
    this.emailFormControl.markAsTouched();
    this.verificationCodeControl.setValidators(Validators.required);
    this.emailFormControl.setValidators([
      Validators.required,
      ArcValidators.email
    ]);
    this.emailFormControl.updateValueAndValidity();
    this.verificationCodeControl.updateValueAndValidity();
    if (this.verificationFormGroup.valid) {
      this.setVerificationClicked.emit(this.verificationFormGroup.value);
    } else {
      // this.verificationFormGroup.markAsTouched();
      this.verificationCode.markAsTouched();
      this.emailControl.markAsTouched();
    }
  }

  get verificationCode() {
    return this.verificationFormGroup.get('verificationCode');
  }

  get verificationCodeIsInValid() {
    return this.verificationCode.errors && this.verificationCode.touched;
  }

  get emailControl() {
    return this.verificationFormGroup.get('email');
  }
  get emailIsInValid() {
    return this.emailControl.errors && this.emailControl.touched;
  }

  resendCode($event) {
    this.emailFormControl.clearValidators();
    this.verificationCodeControl.clearValidators();
    this.emailFormControl.markAsTouched();
    this.verificationCodeControl.markAsUntouched();
    this.emailFormControl.setValidators([
      Validators.required,
      ArcValidators.email
    ]);
    this.emailFormControl.updateValueAndValidity();
    // this.verificationCodeControl.updateValueAndValidity();
    if (this.emailFormControl.valid) {
      this.resendCodeClicked.emit(this.emailFormControl.value);
    }
  }

  goBack() {
    this.goBackClicked.emit();
  }
}
